<template>
  <div>
    <v-data-table class="elevation-1" :headers="headers" :items="items" :loading="loading" :items-per-page="100"
                  :options.sync="params.options" :server-items-length="params.total"
                  :footer-props="{showFirstLastPage: true, showCurrentPage: true}">
      <template v-slot:top>
        <v-toolbar flat>
          <provider-filter :filters="params.filters"/>
          <v-btn icon @click="quotationUploadDialog = true">
            <v-icon>mdi-tag</v-icon>
          </v-btn>
          <v-btn icon @click="getData">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider/>
      </template>
      <template v-slot:item.price="{ item }">
        <div v-for="quotation in item.quotations" :key="quotation.id">
          {{ quotation.minLimit }} - {{ quotation.maxLimit }} {{ quotation.priceType === 1 ? "KG" : "CBM" }} :
          <span v-if="quotation.price">{{ quotation.price }}元 ({{ quotation.quoteDate }})</span>
        </div>
      </template>
      <template v-slot:item.fees="{ item }">
        <div v-if="item.fees">
          <div v-for="(fee, index) in item.fees" :key="`${item.id}-${fee.name}-${index}`">
            {{ fee.name }}: {{ fee.price }}{{ fee.type === 1 ? "元" : "元/" + (item.calcType === 1 ? "KG" : "CBM") }}
          </div>
        </div>
      </template>
      <template v-slot:item.remark="{ item }">
        <div v-if="item.remark">
          <div v-for="(line, index) in item.remark.split('\n')" :key="`${item.id}-${line}-${index}`">
            {{line}}
          </div>
        </div>
      </template>
    </v-data-table>
    <quotation-upload-dialog v-model="quotationUploadDialog" @reload="getData"/>
    <quotation-dialog v-model="quotationDialog" :filters="params.filters" @reload="getData"/>
  </div>
</template>

<script>
import QuotationDialog from "@/page/Provider/QuotationDialog";
import ProviderFilter from "@/page/Provider/ProviderFilter";
import QuotationUploadDialog from "@/page/Provider/QuotationUploadDialog";

export default {
  name: "QuotationManager",
  components: {QuotationUploadDialog, ProviderFilter, QuotationDialog},
  data() {
    return {
      quotationUploadDialog: false,
      quotationDialog: false,
      loading: true,
      headers: [
        {text: "ID", align: "center", sortable: true, value: "id"},
        {text: "供应商名称", align: "center", sortable: true, value: "providerName"},
        {text: "国家", align: "center", sortable: true, value: "country"},
        {text: "渠道", align: "center", sortable: true, value: "channelName"},
        {text: "渠道类别", align: "center", sortable: true, value: "channelType"},
        {text: "仓库", align: "center", sortable: true, value: "repository"},
        {text: "报价", align: "left", sortable: false, value: "price"},
        {text: "收费项目", align: "left", sortable: false, value: "fees", width: 200},
        {text: "备注", align: "left", sortable: false, value: "remark", width: 300},
      ],
      items: [],
      params: {
        options: {
          sortBy: ["providerName", "country", "channelName", "channelType"],
          sortDesc: [false, false, false, false]
        },
        filters: {
          quoteDate: null,
          search: null,
          provider: null,
          country: null,
          channel: null,
          channelType: null,
          repository: null
        },
        total: null,
      },
      filterDialog: false,
    }
  },
  methods: {
    getData() {
      this.loading = true
      this.items = []
      this.$axios.post('/channels', this.params).then(
          res => {
            this.loading = false
            this.items = res.data.list
            this.params.total = res.data.total
            console.log(this.items)
          }
      )
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    'params.filters': {
      deep: true,
      handler() {
        this.getData()
      }
    }
  },
}
</script>

<style scoped>

</style>